import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { UserProvider } from '@/lib/contexts/user-context';
import { SearchProvider } from '@/lib/contexts/search-context';
import { RootLayout } from '@/components/layout/root-layout';
import "@styles/globals.css";


createInertiaApp({
  resolve: name => {
    const pages = import.meta.glob('./Pages/**/*.jsx', { eager: true });
    return pages[`./Pages/${name}.jsx`]?.default;
  },
  setup({ el, App, props }) {
    
    // Extract user data from page props
    const user = props.initialPage?.props?.user;
    
    // The user object now contains roles and permissions directly
    const initialCurrentUser = user ? {
      ...user,
      // Fallback to separate props if roles/permissions aren't in user object
      roles: user.roles || props.initialPage?.props?.userRoles || [],
      permissions: user.permissions || props.initialPage?.props?.userPermissions || []
    } : null;
        
    createRoot(el).render(
      <UserProvider initialCurrentUser={initialCurrentUser}>
        <SearchProvider>
          <RootLayout>
            <App {...props} />
          </RootLayout>
        </SearchProvider>
      </UserProvider>
    )
  },
})